import history from './history';

export default history;
